//封装组件库
import foot from '../components/footer.vue';
import shouye from '../components/shouye';
import qiyeRenzh from '../components/ziliao/authen_renZ.vue';
import qiyeBiangeng from '../components/ziliao/authen_biangeng.vue';
import qiyeSucess from '../components/ziliao/authen_sucess.vue';
import qiyetijiaoZL from '../components/ziliao/authen_tijiaoZL.vue';
import sellPrice from '../components/home/sellPrice.vue';
import moneyManage from '../components/home/moneyManage.vue';
import prePayment from '../components/home/prePayment.vue';
import specialMoney from '../components/home/specialMoney.vue';
import stationInfo from '../components/home/stationInfo.vue';
import userManage from '../components/home/userManage.vue';
import charge from '../components/home/charge.vue';
import companyUser from '../components/home/companyUser.vue';
import announcement from '../components/home/announcement.vue';
import notice from '../components/home/notice.vue';
import accountSafe from '../components/home/accountSafe.vue';
import preDeclare from '../components/home/preDeclare.vue';
import notpreDeclare from '../components/home/notpreDeclare.vue';
import carManage from '../components/home/carManage.vue';
import onlineCharge from '../components/home/onlineCharge.vue';
import settlement from '../components/home/settlement.vue';
import dealPlatform from '../components/home/index.vue';
import memberAgreement from '../components/memberAgreement.vue';
import withdraw from '../components/home/withdraw.vue';
import accountMgt from '../components/home/accountMgt.vue';
import advance from '../components/home/advance.vue';
import arbitrate from '../components/home/arbitrate.vue';
import customer from '../components/home/customer.vue';
import finance from '../components/home/finance.vue';
import tradeCash from '../components/home/tradeCash.vue';

const components = {
  foot,
  shouye,
  qiyeRenzh,
  qiyeSucess,
  qiyetijiaoZL,
  qiyeBiangeng,
  sellPrice,
  moneyManage,
  prePayment,
  specialMoney,
  stationInfo,
  userManage,
  charge,
  companyUser,
  announcement,
  notice,
  accountSafe,
  preDeclare,
  notpreDeclare,
  carManage,
  settlement,
  onlineCharge,
  dealPlatform, // 交易平台首页
  memberAgreement,
  withdraw,
  accountMgt,
  advance,
  arbitrate,
  customer,
  finance,
  tradeCash
};

const install = (Vue = {}) => {
  if (install.installed) return;
  Object.keys(components).forEach((component) => {
    Vue.component(components[component].name, components[component]);
  });
  install.installed = true;
};
install.installed = false;

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
  install.installed = true;
}

const Vcomp = {
  ...components,
  install
};

export default Vcomp;
